<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'Question',
		data() {
			return {
				componentName: 'Question',
				history: -1,
				choice: -1,
				mutual: -1,
				give: -1,
				receive: -1,
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters([]),
		},
		methods: {},
		async mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<Question> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<v-flex class="Question grow">
		<v-card class="ma-2 flex column grow">
			<v-card-title>Question 22</v-card-title>
			<v-card-text class="grow">
				<p>
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aliquam quod
					id alias ratione ipsum sint quia et nesciunt modi quisquam blanditiis
					rerum deleniti odio aliquid optio, cumque est vel a. More Info
					<v-icon>info</v-icon>
				</p>
			</v-card-text>
			<v-card-actions class="flex column">
				<p class="mt-2">We _____ done this</p>
				<v-btn-toggle style="width:100%;" v-model="choice">
					<v-btn color="green" block value="yes" class="white--text">
						HAVE
					</v-btn>
					<v-btn color="blue" block value="maybe" class="white--text">
						MIGHT HAVE
					</v-btn>
					<v-btn color="red" block value="no" class="white--text">
						HAVE NOT
					</v-btn>
				</v-btn-toggle>
				<p class="mt-2">I _____ do this</p>
				<v-btn-toggle style="width:100%;" v-model="choice">
					<v-btn color="green" block value="yes" class="white--text">
						WANT TO
					</v-btn>
					<v-btn color="blue" block value="maybe" class="white--text">
						WILL
					</v-btn>
					<v-btn color="red" block value="no" class="white--text">
						WONT
					</v-btn>
				</v-btn-toggle>
			</v-card-actions>
		</v-card>
		<!-- <p>
			This is a sample question. This is a sample question. This is a sample
			question. This is a sample question. This is a sample question. This is a
			sample question.
		</p>

		<v-btn-toggle style="width:100%;" v-model="choice">
			<v-btn color="green" block flat value="yes">
				YES
			</v-btn>

			<v-btn color="red" block flat value="no">
				No
			</v-btn>
		</v-btn-toggle>

		<v-btn-toggle style="width:100%;" v-model="choice">
			<v-btn color="green" block flat value="yes">
				YES
			</v-btn>
			<v-btn color="blue" block flat value="maybe">
				Maybe
			</v-btn>
			<v-btn color="red" block flat value="no">
				No
			</v-btn>
		</v-btn-toggle>

		<v-btn block outline color="green">Yes!!!</v-btn>
		<v-btn block outline color="indigo" v-model="choice" value="maybe"
			>Sure / Maybe</v-btn
		>
		<v-btn block outline color="red">No Thanks</v-btn>

		<v-switch
			v-model="choice"
			label="YES!!!"
			color="success"
			value="yes"
			hide-details
		></v-switch>
		<v-switch
			v-model="choice"
			label="Sure / Maybe"
			color="success"
			value="maybe"
			hide-details
		></v-switch>
		<v-switch
			v-model="choice"
			label="No Thanks"
			color="success"
			value="no"
			hide-details
		></v-switch>
		{{ componentName }} -->
	</v-flex>
</template>
<!-- ******************************************************************* -->
<style scoped>
	.column {
		flex-direction: column;
	}
	.Question {
	}
</style>
